module.exports = __webpack_public_path__ + "static/media/host_minipc.2457a2ff.png";